import { useEffect } from 'react';

const SITE = 'VotePlan';

/**
 * Sets document.title and meta description for SEO.
 */
export function useSEO({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : SITE;
  }, [title]);

  useEffect(() => {
    if (!description) return;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [description]);
}
